import { ImageScale } from '@front-app/services/ImageApi/ImageModel';
import { singleton } from '@front-app/util/interface';
import { getImageFetchers } from '@front-app/workers/ImageWorkerWrapper';
import { getCurrentUserStore } from '../modules/currentUser';
import { createV2ImageStore } from '../modules/image';
import { getUserStore } from '../modules/user';

export const UserStore = singleton(getUserStore);
export const CurrentUserStore = getCurrentUserStore(UserStore.getInstance());
export const UserAvatarStore = createV2ImageStore(() => getImageFetchers().getUserAvatar, ImageScale.LARGE);
